import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import MESSAGES from "../constants/messages";
import { handleSnackBar } from "./global";
// import { postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import searchService from "../services/search.service";

export const searchListing = createAsyncThunk(
  "manageListing/fetch",
  async (data: any, { dispatch }: any) => {
    try {
      dispatch(setLoadingList(true));
      const resp: any = await searchService.search({ body: data }); //postAPICall(nextAPIRoutes.SEARCH_LISTING, data)

      return resp.data.data ?? [];
    } catch (e: any) {
      console.log(e);
      dispatch(setLoadingList(false));

      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const searchListingDetails = createAsyncThunk(
  "manageListing/searchListingDetails",
  async ({ id }: any, { dispatch }) => {
    try {
      dispatch(setLoadingDetails(true));
      const resp: any = await searchService.searchListingDetails({
        body: { id },
      }); //postAPICall(nextAPIRoutes.SEARCH_DETAILS, { id })
      dispatch(setLoadingDetails(false));
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(setLoadingDetails(false));

      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const searchListingDetailsOwner = createAsyncThunk(
  "manageListing/searchListingDetailsOwner",
  async ({ id }: any, { dispatch }) => {
    try {
      dispatch(setLoadingDetails(true));
      const resp: any = await searchService.searchListingDetailsOwner({
        body: { id },
      }); //postAPICall(nextAPIRoutes.SEARCH_DETAILS, { id })
      dispatch(setLoadingDetails(false));
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(setLoadingDetails(false));

      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

const typeMapping: any = {
  0: "All",
  1: "TRACTOR",
  2: "ATTACHMENT",
  3: "EQUIPMENTS",
};
const searchListingSlice = createSlice({
  name: "searchListing",
  initialState: {
    list: [],
    suggestionList: [],
    listMeta: {},
    masterList: [],
    selectedType: 0,
    isMapView: false,
    loading: false,
    loadingDetails: false,
    filteredFromCartVendor: false,
    instantBooking: false,

    searchLocation: {},
    page: 1,
    selectedHp: 0,
    prices: [0, 10000],
    filters: {},
    searchManufacturerIds: [] as Array<number>,
    searchAttachmentIds: [] as Array<number>,
    searchDates: [],

    listingDetails: {},
    listingDetailsOwner: {},
  },
  reducers: {
    setSelectedType: (state, { payload }: { payload: number }) => {
      state.selectedType = payload;
    },
    setPage: (state, { payload }: { payload: number }) => {
      state.page = payload;
    },
    setSearchFilters: (state, { payload }: { payload: object }) => {
      state.filters = { ...state.filters, ...payload };
    },
    setSearchDates: (state, { payload }: { payload: any }) => {
      state.searchDates = payload;
    },
    setSearchManufacturerIds: (state, { payload }: { payload: any }) => {
      if (typeof payload === "number") {
        state.searchManufacturerIds = state.searchManufacturerIds.includes(
          payload
        )
          ? state.searchManufacturerIds.filter((r) => r !== payload)
          : [...state.searchManufacturerIds, payload];
      } else {
        state.searchManufacturerIds = payload;
      }
    },
    setSearchAttachmentsIds: (state, { payload }: { payload: any }) => {
      if (typeof payload === "number") {
        state.searchAttachmentIds = state.searchAttachmentIds.includes(payload)
          ? state.searchAttachmentIds.filter((r) => r !== payload)
          : [...state.searchAttachmentIds, payload];
      } else {
        state.searchAttachmentIds = payload;
      }
    },
    setLoadingList: (state, { payload }: { payload: boolean }) => {
      state.loading = payload;
    },
    setLoadingDetails: (state, { payload }: { payload: boolean }) => {
      state.loadingDetails = payload;
    },
    setIsMapView: (state, { payload }: { payload: boolean }) => {
      state.isMapView = payload;
    },
    setInstantBooking: (state, { payload }: { payload: boolean }) => {
      state.instantBooking = payload;
    },
    setSearchLocation: (state, { payload }: { payload: object }) => {
      state.searchLocation = payload;
    },
    setSelectedHp: (state, { payload }: { payload: number }) => {
      state.selectedHp = payload === state.selectedHp ? 0 : payload;
    },
    setPrices: (state, { payload }: { payload: Array<number> }) => {
      state.prices = payload;
    },
    handleTypeChange: (state) => {
      if (state.selectedType === 0) {
        state.list = state.masterList;
      } else {
        const filterData = state.masterList.filter(
          (v: any) => v.type === typeMapping[state.selectedType]
        );
        state.list = filterData;
      }
    },
    clearSearchFilters: (state) => {
      state.searchLocation = {};
      state.selectedHp = 0;
      state.prices = [0, 10000];
      state.filters = {};
      state.searchManufacturerIds = [] as Array<number>;
      state.searchAttachmentIds = [] as Array<number>;
      state.searchDates = [];
      state.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        searchListing.fulfilled,
        (state, { payload }: { payload: any }) => {
          state.list = payload?.list ?? [];
          state.suggestionList = payload?.suggestions ?? [];
          state.listMeta = payload?.meta ?? {};
          state.loading = false;
          state.filteredFromCartVendor = payload?.filteredFromCartVendor;
          if (payload?.list?.length === 0) {
            state.isMapView = false;
          }
        }
      )
      .addCase(searchListingDetails.fulfilled, (state, { payload }) => {
        state.listingDetails = payload;
      })
      .addCase(searchListingDetailsOwner.fulfilled, (state, { payload }) => {
        state.listingDetailsOwner = payload;
      });
  },
});

export default searchListingSlice.reducer;
export const {
  setSelectedType,
  setLoadingList,
  handleTypeChange,
  setIsMapView,
  setSearchLocation,
  setPage,
  setSelectedHp,
  setPrices,
  setSearchFilters,
  setSearchManufacturerIds,
  setSearchAttachmentsIds,
  setSearchDates,
  setLoadingDetails,
  clearSearchFilters,
  setInstantBooking,
} = searchListingSlice.actions;
